import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Lightning } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B] grain px-4">
      <div className="w-full max-w-md relative z-[2]">
        <Link to="/" className="flex items-center gap-2.5 mb-10 justify-center">
          <div className="w-9 h-9 border border-[#00F0FF] flex items-center justify-center">
            <Lightning size={20} weight="fill" className="text-[#00F0FF]" />
          </div>
          <span className="font-semibold tracking-tight text-lg">MDM Forge</span>
        </Link>

        <div className="border border-[#27272A] bg-[#121214] p-8">
          <h1 className="text-2xl tracking-tight mb-1">Welcome back</h1>
          <p className="text-sm text-[#A1A1AA] mb-6 font-mono">Sign in to your workspace</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs text-[#A1A1AA] mb-1.5 font-mono">EMAIL</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#0A0A0B] border border-[#27272A] px-3 py-2.5 text-sm font-mono focus:border-[#00F0FF] focus:outline-none transition-colors duration-200"
                placeholder="you@company.com"
              />
            </div>
            <div>
              <label className="block text-xs text-[#A1A1AA] mb-1.5 font-mono">PASSWORD</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#0A0A0B] border border-[#27272A] px-3 py-2.5 text-sm font-mono focus:border-[#00F0FF] focus:outline-none transition-colors duration-200"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-xs text-[#FF5F56] font-mono border border-[#FF5F56]/30 bg-[#FF5F56]/5 px-3 py-2">
                {error}
              </div>
            )}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#00F0FF] text-[#0A0A0B] font-medium py-2.5 text-sm hover:bg-[#00d4e0] transition-colors duration-200 disabled:opacity-50"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="text-center mt-4">
            <Link to="/forgot-password" data-testid="go-forgot" className="text-xs text-[#71717A] hover:text-[#00F0FF] transition-colors duration-200 font-mono">
              Forgot password?
            </Link>
          </div>

          <p className="text-xs text-[#71717A] mt-6 text-center font-mono">
            No account?{" "}
            <Link to="/register" data-testid="go-register" className="text-[#00F0FF] hover:underline">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
